import { useCallback, useEffect, useRef } from 'react';

export function useInfiniteScroll(
  callback: () => void,
  options?: IntersectionObserverInit,
) {
  const observerRef = useRef<IntersectionObserver | null>(null);
  const callbackRef = useRef(callback);

  callbackRef.current = callback;

  const setLoaderRef = useCallback(
    (node: HTMLDivElement | null) => {
      if (!node) {
        return;
      }

      observerRef.current?.disconnect();

      observerRef.current = new IntersectionObserver(([entry]) => {
        if (entry.isIntersecting) {
          callbackRef.current();
        }
      }, options);

      observerRef.current.observe(node);
    },
    [options],
  );

  useEffect(() => {
    return () => {
      observerRef.current?.disconnect();
    };
  }, []);

  return setLoaderRef;
}
